var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { mediaApi } from '@sitecore-jss/sitecore-jss/media';
import PropTypes from 'prop-types';
import React from 'react';
import { getEEMarkup, } from '@sitecore-jss/sitecore-jss-react';
import Image from 'next/image';
export const sitecoreLoader = ({ src, width }) => {
    const [root, paramString] = src.split('?');
    const params = new URLSearchParams(paramString);
    params.set('mw', width.toString());
    return `${root}?${params}`;
};
export const NextImage = (_a) => {
    var { editable, imageParams, field, mediaUrlPrefix } = _a, otherProps = __rest(_a, ["editable", "imageParams", "field", "mediaUrlPrefix"]);
    // next handles src and we use a custom loader,
    // throw error if these are present
    if (otherProps.src) {
        throw new Error('Detected src prop. If you wish to use src, use next/image directly.');
    }
    const dynamicMedia = field;
    if (!field ||
        (!dynamicMedia.editable && !dynamicMedia.value && !dynamicMedia.src)) {
        return null;
    }
    const imageField = dynamicMedia;
    // we likely have an experience editor value, should be a string
    if (editable && imageField.editable) {
        return getEEMarkup(imageField, imageParams, mediaUrlPrefix, otherProps);
    }
    // some wise-guy/gal is passing in a 'raw' image object value
    const img = dynamicMedia.src
        ? field
        : dynamicMedia.value;
    if (!img) {
        return null;
    }
    const attrs = Object.assign(Object.assign(Object.assign({}, img), otherProps), { src: mediaApi.updateImageUrl(img.src, imageParams, mediaUrlPrefix) });
    const imageProps = Object.assign(Object.assign({}, attrs), { 
        // force replace /media with /jssmedia in src since we _know_ we will be adding a 'mw' query string parameter
        // this is required for Sitecore media API resizing to work properly
        src: mediaApi.replaceMediaUrlPrefix(attrs.src, mediaUrlPrefix) });
    const loader = (otherProps.loader ? otherProps.loader : sitecoreLoader);
    if (attrs) {
        return React.createElement(Image, Object.assign({ loader: loader }, imageProps));
    }
    return null; // we can't handle the truth
};
NextImage.propTypes = {
    field: PropTypes.oneOfType([
        PropTypes.shape({
            src: PropTypes.string.isRequired,
        }),
        PropTypes.shape({
            value: PropTypes.object,
            editable: PropTypes.string,
        }),
    ]),
    editable: PropTypes.bool,
    mediaUrlPrefix: PropTypes.instanceOf(RegExp),
    imageParams: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]).isRequired),
};
NextImage.defaultProps = {
    editable: true,
};
NextImage.displayName = 'NextImage';
